import React, { useState, useEffect } from 'react'
import { errorMap } from './BaseComponent'
import Multiselect from 'multiselect-react-dropdown';

export default function MultiselectComponent({ API, select, selected, endpoint, table, isObject = false }) {
    const [options, setOptions] = useState([])
  
    const getOptions = () => {
      let url = API+endpoint
      const params = {
        "limit": 100,
        "offset": 0,
        archived: false
      }
  
      fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer " + sessionStorage.getItem('token')
          },
          body: JSON.stringify(params)
        })
      .then((response) => {
          return response.json()
      })
      .then((result) => {
        if (result.status.success) {
            let tempArray = []
            const filteredResults = table === "forms" ? result.data[table].filter((item) => item.category === "personal_data" || item.category === "device") : result.data[table]
            for (let i = 0; i < filteredResults.length; i++) {
                const element = filteredResults[i];
                if(isObject) {
                  tempArray.push(element)
                } else {
                  tempArray.push(element.ident)
                }
            }
            // console.log(tempArray)
          setOptions(tempArray)
        } else {
          window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error) }}), true);
        }
      }, (error) => {
        console.log(error)
      })
    }
  
    useEffect(() => {
      getOptions()
      // eslint-disable-next-line
    }, [])

    const parsedSelected = selected.length > 0 && typeof selected[0] === "string"
    
    return (
      <Multiselect
        options={options}
        selectedValues={selected}
        onSelect={select}
        onRemove={select}
        isObject={isObject}
        displayValue="ident"
        groupBy={table === "forms" ? "category" : ""}
      />
    )
  }